function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  fill: "#f0f3f8",
  d: "M0 0h1855.98v1055.78H0z",
  "data-name": "Layer 3"
}));

var SvgBespokenBackground = function SvgBespokenBackground(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 1855.98 1055.78"
  }, props), _ref);
};

export default SvgBespokenBackground;